import React, { Component } from 'react';
import { FormControl, FormGroup, Button, InputGroup } from "react-bootstrap";
import './SearchHero.css';
import './SearchOptions.css';
import axios from "axios";
import mixpanel from "mixpanel-browser";
import cookie from 'react-cookie';

class FeedbackForm extends Component {

	constructor() {
		super();
		this.state = { 
			email: '', 
			status: 'pristine', 
			submitting: false,
			isLoggedIn: cookie.load('webfinery.jwt') != null
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.getSubmitLabel = this.getSubmitLabel.bind(this);
		this.subscriptionInputGroup = this.subscriptionInputGroup.bind(this);
		this.mixpanel = mixpanel;
	}

	handleSubmit(event) {
		event.preventDefault();        
        this.setState({submitting: true});

       	let that = this;

       	let params = {
       		email: this.state.email,
       		list: this.props.list
       	}

        axios
            .post("/api/newsletter/subscriptions", params)
            .then(function(response) {            	
                that.mixpanel.track("Newsletter subscription", {
                    email: params.email,
                    list: params.list,
                    source: 'webfinery.com/search',
                    success: true
                });
                that.setState({ email: '', status: 'success', submitting: false });
            })
            .catch(function(error) {
                that.mixpanel.track("Newsletter subscription", {
                    email: params.email,
                    list: params.list,
                    source: 'webfinery.com/search',                   
                    success: false,
                    error: error
                });
                that.setState({ status: 'error', submitting: false });
            });
	}

	handleChange(event) {
		this.setState({email: event.target.value});
	}

	getSubmitLabel() {
		return this.props.submitLabel != null ? this.props.submitLabel : "Send";
	}

	getAfterMessage(message) {
		return <Button disabled style={{color: '#383', background: 'transparent', border: 'transparent'}}>{message}</Button>
	}

	subscriptionInputGroup() {
		const searchLabel = this.state.submitting ? 'Sending...' : this.getSubmitLabel();
		return (			
		    <InputGroup>
		        {!this.state.isLoggedIn && <FormControl
		            type="email"
		            placeholder="Your work email"
		            style={{borderColor: "#5bc0de"}}
		            onChange={this.handleChange}
		            required="required"
		        />}
		        <InputGroup.Button>
		            <Button
		                disabled={this.state.submitting}
		                type="submit"
		                bsStyle="success"
		            >
		                {searchLabel}
		            </Button>
		        </InputGroup.Button>
		    </InputGroup>
	    )
	}

	successMessage() {
		const message = this.props.doneMessage ? this.props.doneMessage : "Done!";
		return (
			<div className="doneMessage">{this.getAfterMessage(message)}</div>
		);
	}

	errorMessage() {
		return this.getAfterMessage("Sorry, cannot send at the moment, please try later");
	}


	inputGroup() {
        if (this.state.status === 'pristine') {
        	return this.subscriptionInputGroup();
        } else if (this.state.status === 'success') {
        	return this.successMessage();
        } else {
        	return this.errorMessage();
        }
	}

	render() {
		return (
	        <form onSubmit={this.handleSubmit}>
	            <FormGroup style={{marginBottom: 0}}>
	            	{this.inputGroup()}
	            </FormGroup>
	        </form>
		)
	}
}

export default FeedbackForm;







// WEBPACK FOOTER //
// ./src/FeedbackForm.js